import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 0S ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 1min ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 5min ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 10min ")
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "el-icon-question" }, null, -1)
const _hoisted_7 = { style: {"text-align":"center"} }

import { defineComponent, reactive, toRefs, ref, onMounted } from 'vue'
import type { VNode, VNodeProps } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { api } from '@/apis/user'
import { ElMessage } from 'element-plus'
import { getLoginName, getLoginId } from '@/utils/cookies'
import { trigger } from '@vue/reactivity'
import { useI18n } from "vue-i18n";
interface Option {
  key: number
  label: string
  disabled: boolean
}
interface stateTypes {
  data: { key: String, label: String, name: String }[]
  gids: { key: String, label: String }[]
}
interface funclistTypes {
  funcList: { id: number, name: String }[]
}
interface Virtua {
  adminVirtua: any
  adminVirtuaOne: any
}

export default _defineComponent({
  expose: [],
  setup(__props) {

const route = useRoute()
const { t } = useI18n();
const routerList = useRouter()
const getloginName = getLoginName()
const getloginId = getLoginId()
const userForm = ref()
const Virtua = reactive<Virtua>({
  adminVirtua: 0,
  adminVirtuaOne: 0
})
// 表单校验
const rules = reactive({
password:[
    { required: true, message: t('login.plasepassword'), trigger: 'blur' },
    { min: 6, max: 12, message: t('input.Password length should be between 6 and 12 characters'), trigger: 'blur' },
    {
      validator: (rule: any, value: any, callback: any) => {
        const reg = /^[A-Za-z0-9_]+$/
        if (!reg.test(value)) {
          callback(new Error(t('input.Please enter letters or numbers or a combination')))
        } else {
          callback()
        }
      },
      trigger: 'blur'
    }
  ],
  agentpwd: [
    { required: true, message: t('login.plasepassword'), trigger: 'blur' },

    { min: 6, max: 12, message: t('input.Password length should be between 6 and 12 characters'), trigger: 'blur' },
    {
      validator: (rule: any, value: any, callback: any) => {
        const reg = /^[A-Za-z0-9_]+$/
        if (!reg.test(value)) {
          callback(new Error(t('input.Please enter letters or numbers or a combination')))
        } else {
          callback()
        }
      },
      trigger: 'blur'
    }
  ],
  iccid:[{ required: true, message: t('input.Please enter a 20-digit ICCID number'), trigger: 'blur'},
  {min: 19, max:20, message: t('input.The ICCID number should be 19 or 20 digits long'), trigger: 'blur' }
  ],
  iccidList:[{required: true, message: t('input.Please enter a 20-digit ICCID number'), trigger: 'blur'}],
  iccidCount:[{required: true, message: t('input.Enter the number of accounts you want to create'), trigger: 'blur'}],
  funcsList: [{ required: true, message: t('input.Please select function group'), trigger: 'change' }],
  funcValueList: [
    {
      required: true,
      message: t('input.Please select the corresponding permissions'),
      trigger: 'change'
    }
  ],
  defaultGid: [
    { required: true, message: t('input.Please select a default group'), trigger: 'change' }
  ]
})
const uid = route.query.uid || ''
const checkcceate = ref(false)
const checkDisabledType_func = ref(false) // false 为可编辑状态
const checkType_call = ref(1)
const dataList = reactive<stateTypes>({
  data: [],
  gids: []
})
const funcDataList = reactive<funclistTypes>({
  funcList: []
})

const formface = reactive({
  form: {
    type: ref(3), // 账号类型 0为三年期账号, 3为一年期账号
    agentpwd: '',
    name:'',
    nameNo: null,
    iccid:'',
    iccidCount:'',
    funcsList: ref<any>([]),
    funcValueList: ref<any>([]),
    iccidList:[''],
    gpsInterval: ref(0),
    defaultGids:'',
    defaultGid: [],
    pttUserEntity:{
      keys: [],
      iccidList:[''],
      defaultGids: '',
      gpsInterval: 0,
      type:0,
      validMonths: 36,
      funcsList: [],
      iccid: "",
      iccidCount: "",
      agentpwd: "",
      name:'',
      nameNo: null,
      iccidPri: 0
    }
  }
})

// 详细数据
const addInput = ()=>{
  formface.form.iccidList.push('')
}
const deleteInput=()=>{
  formface.form.iccidList.splice(formface.form.iccidList.length-1)

}
// 连号创建与非连号创建
const tochangeCreate = () => {
  if (checkType_call.value === 1) {
    checkcceate.value = false
    formface.form.iccidList=['']
  } else {
    checkcceate.value = true
    formface.form.iccid=''
    formface.form.iccidCount=''
  }
}
// 提交表单
const submit = () => {
  console.log('submit?')
  formface.form.defaultGids=formface.form.defaultGid.join(',')
  formface.form.pttUserEntity.defaultGids= formface.form.defaultGid.join(',')
  formface.form.pttUserEntity.gpsInterval=formface.form.gpsInterval
  formface.form.pttUserEntity.type=formface.form.type
  formface.form.pttUserEntity.funcsList=formface.form.funcsList
  formface.form.pttUserEntity.iccid=formface.form.iccid
  formface.form.pttUserEntity.iccidCount=formface.form.iccidCount
  formface.form.pttUserEntity.agentpwd=formface.form.agentpwd
  formface.form.pttUserEntity.name = formface.form.name
  formface.form.pttUserEntity.iccidList=formface.form.iccidList
  formface.form.pttUserEntity.nameNo = formface.form.nameNo
  console.log(formface.form)
    userForm.value.validate(async(valid: any) => {
      console.log(formface)
      if (valid) {
        const statuses: any = await api.detail.addiccid(formface.form)
        console.log(statuses, 'sub-add-res?')
        if (statuses.data.status === 200) {
          userForm.value.resetFields()
          routerList.push({ path: '/userlist' })
          ElMessage.success(t('table.success'))
        } else {
          ElMessage.warning(statuses.data.message)
        }
      } else {

      }
    })
}

const remoteMethod =(query:string) =>{

  if(query){
    setTimeout(() =>{
      getInfo(query)
    },200)
  }else{
    getInfo(query)
  }
}
// 初始化
const getInfo = async(gname?:any) => {

    // 新增
    console.log('add?')
    // 查询管理员下所有币种的数量
    // const Count: any = await api.detail.adminAllVirtua({ adminid: null })
    //  1. 查询管理员所有的币
    const AllVirtua: any = await api.detail.adminAllVirtua({})

    // 2. 查询管理员功能组列表
    const funcGroupData: any = await api.detail.groupFunList({
      pageNo: 1,
      pageSize: 200,
      gname:gname
    })
    // 3. 查询账号可加入的群组(过滤掉满员的群组列表)
    const userNoJoinGroupsList: any = await api.list.userNoJoinGroupsList({
      pageNo: 1,
      pageSize: 200,
      gname:gname
    })

        dataList.gids =  userNoJoinGroupsList.data.data.resultList;
    // 4. 查询管理员的优惠月份
    // const preferentialMonths: any = await api.detail.preferentialMonths()
    // 5. 查询管理员设置的有效年份

    Virtua.adminVirtua = AllVirtua.data.data[1]
    Virtua.adminVirtuaOne = AllVirtua.data.data[11]

    const funcGroup = funcGroupData.data.data
    funcDataList.funcList = funcGroup


}
onMounted(() => {
  getInfo()
})

return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")
  const _component_el_radio_group = _resolveComponent("el-radio-group")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      model: formface.form,
      "label-width": "120px",
      width: "200",
      rules: rules,
      ref: userForm
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('table.AccountType')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: formface.form.type,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (formface.form.type = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, {
                  label: 3,
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("form.OneYear")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: 0,
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("form.ThreeYears")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('form.GPS reporting cycle')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: formface.form.gpsInterval,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (formface.form.gpsInterval = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, {
                  label: 0,
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: 60,
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: 300,
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: 600,
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _hoisted_6
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('form.Permission'),
          prop: "funcValueList"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_checkbox_group, {
              modelValue: formface.form.funcValueList,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (formface.form.funcValueList = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox, { label: 0 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("form.Group Call")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_checkbox, { label: 1 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("form.Switch Group")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_checkbox, { label: 3 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("form.Temp call")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_checkbox, { label: 9 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("form.Across-groups temp call")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('form.functiongroup'),
          prop: "funcsList"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_checkbox_group, {
              modelValue: formface.form.funcsList,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (formface.form.funcsList = $event)),
              disabled: checkDisabledType_func.value,
              max: 1
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(funcDataList.funcList, (item) => {
                  return (_openBlock(), _createBlock(_component_el_checkbox, {
                    key: item.id,
                    label: item.id
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('table.defaultgroup'),
          prop: "defaultGid"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              class: "m-2",
              placeholder: _ctx.$t('input.Please select default group'),
              modelValue: formface.form.defaultGid,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (formface.form.defaultGid = $event)),
              filterable: "",
              multiple: "",
              remote: "",
              "reserve-keyword": "",
              "remote-method": remoteMethod
            }, {
              default: _withCtx(() => [
                (dataList.gids.length !== 0)
                  ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(dataList.gids, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.gid,
                        label: item.name,
                        value: item.gid
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["placeholder", "modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('table.designation')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: formface.form.name,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (formface.form.name = $event)),
              "max-length": "12",
              placeholder: _ctx.$t('input.Please enter a name')
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('form.name starting number')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: formface.form.nameNo,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (formface.form.nameNo = $event)),
              maxlength: "4",
              placeholder: _ctx.$t('input.Please input Name Starting number')
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('form.agentpw'),
          prop: "agentpwd"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: formface.form.agentpwd,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (formface.form.agentpwd = $event)),
              type: "password",
              "show-password": "",
              maxlength: "12",
              placeholder: 
            _ctx.$t(
              'input.Please enter 6 to 12 characters to support letters and numbers'
            )
          
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('form.WhetherHyphen'),
          onChange: tochangeCreate
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: checkType_call.value,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (checkType_call.value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, {
                  label: 1,
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("form.Serial number creation")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: 0,
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("form.Created without hyphens")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _withDirectives(_createVNode(_component_el_form_item, {
          label: _ctx.$t('form.ICCID start number'),
          prop: checkcceate.value === false ? 'iccid' : ''
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: formface.form.iccid,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (formface.form.iccid = $event)),
              maxlength: "20",
              placeholder: 
            _ctx.$t('input.Please enter a 20-digit ICCID starting number')
          
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["label", "prop"]), [
          [_vShow, !checkcceate.value]
        ]),
        _withDirectives(_createVNode(_component_el_form_item, {
          label: _ctx.$t('form.numofIccid')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: formface.form.iccidCount,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (formface.form.iccidCount = $event)),
              maxlength: "5",
              placeholder: _ctx.$t('input.Please enter the number of ICCID numbers')
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["label"]), [
          [_vShow, !checkcceate.value]
        ]),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(formface.form.iccidList, (item, index) => {
          return _withDirectives((_openBlock(), _createBlock(_component_el_form_item, {
            label: "iccid:",
            key: index,
            prop: "iccidList"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formface.form.iccidList[index],
                "onUpdate:modelValue": ($event: any) => (formface.form.iccidList[index] = $event),
                maxlength: "20",
                placeholder: _ctx.$t('input.Please enter a 20-digit ICCID number')
              }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
            ]),
            _: 2
          }, 1536)), [
            [_vShow, checkcceate.value]
          ])
        }), 128)),
        _withDirectives(_createVNode("div", _hoisted_7, [
          _createVNode(_component_el_button, {
            onClick: addInput,
            type: "primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("table.add")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            onClick: deleteInput,
            type: "danger"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("table.delete")), 1)
            ]),
            _: 1
          })
        ], 512), [
          [_vShow, checkcceate.value]
        ]),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              onClick: _cache[12] || (_cache[12] = ($event: any) => (submit())),
              size: "large",
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("table.submit")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}
}

})